<template>
  <div>
    <div
      v-if="subject && subject.id"
    >
      <span class="mr-1">{{ ambassadorName }}</span>
      <span>(ID: {{ subject.id }})</span>
    </div>
    <v-tooltip
      v-else-if="(!subject || !subject.id) && isTooltipActive"
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="font-italic font-weight-thin red--text"
          v-text="'empty'"
        />
      </template>
      {{ tooltip }}
    </v-tooltip>
    <div
      v-else
      class="font-italic font-weight-thin red--text"
      v-text="'empty'"
    />
  </div>
</template>

<script>
export default {
  name: 'NameFirstNameLastIdOrEmpty',
  props: {
    subject: {
      type: Object,
      default: () => ({}),
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  computed: {
    ambassadorName() {
      let firstNameBlock = this.subject.first_name ? `${this.subject.first_name} ` : '';
      const lastNameBlock = this.subject.last_name ? `${this.subject.last_name} ` : '';

      if (!firstNameBlock && !lastNameBlock) {
        firstNameBlock = this.subject.nickname ? `${this.subject.nickname} ` : '';
      }

      return `${firstNameBlock}${lastNameBlock}`;
    },
    isTooltipActive() {
      return this.tooltip.length > 0;
    },
  },
};
</script>

<style scoped>

</style>
